import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { MessageCircle, Sparkles } from 'lucide-react';
import { services, businessInfo } from '../data/mock';
import { trackWhatsApp } from '../lib/analytics';

const Services = () => {
  const handleWhatsApp = (serviceName) => {
    trackWhatsApp('service_card', { service: serviceName });
    const message = `Olá! Vim pelo site da ABR Barbearia e gostaria de agendar: ${serviceName}`;
    const url = `https://wa.me/${businessInfo.phone}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <section id="servicos" className="py-20 bg-transparent">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/5 mb-6">
            <Sparkles className="h-4 w-4 text-[#D4AF37]" />
            <span className="text-[#D4AF37] text-xs uppercase tracking-widest font-semibold">Nossos Serviços</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Preços claros. <span className="text-[#D4AF37]">Qualidade premium.</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            Serviços especializados com técnica, precisão e produtos de alta qualidade para valorizar seu estilo único.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card 
              key={service.id}
              data-testid={`service-card-${service.id}`}
              className={`relative bg-zinc-900/90 backdrop-blur-md border-zinc-800 hover:border-[#D4AF37] transition-all duration-500 group overflow-hidden hover:-translate-y-2 hover:shadow-2xl hover:shadow-[#D4AF37]/20 ${
                service.highlight ? 'ring-2 ring-[#D4AF37]/50 lg:scale-[1.02]' : ''
              }`}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {service.highlight && (
                <div className="absolute top-4 right-4 z-10 bg-[#D4AF37] text-black text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider">
                  Mais Pedido
                </div>
              )}
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.name}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-zinc-900 via-zinc-900/50 to-transparent"></div>
              </div>
              <CardHeader>
                <div className="flex items-start justify-between gap-3">
                  <CardTitle className="text-white text-2xl group-hover:text-[#D4AF37] transition-colors">
                    {service.name}
                  </CardTitle>
                  <div className="flex-shrink-0 text-right">
                    <div className={`text-2xl font-bold ${service.price === 'Consultar' ? 'text-gray-400 text-lg' : 'text-[#D4AF37]'}`}>
                      {service.price}
                    </div>
                  </div>
                </div>
                <CardDescription className="text-gray-400 text-base">
                  {service.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <Button 
                  onClick={() => handleWhatsApp(service.name)}
                  data-testid={`service-cta-${service.id}`}
                  variant="outline"
                  className="w-full border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
                >
                  <MessageCircle className="mr-2 h-4 w-4" />
                  Agendar Agora
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;